import { useEffect, useState } from 'react';
import { PostUtil } from 'src/pages/new-post-new/post-util';
import FacebookPostImagesPreview from './facebook-post-images-preview.component';
import FacebookPostVideoPreview from './facebook-post-video-preview.component';

const FacebookPostPreview = ({ data }) => {
  const [isVideo, setIsVideo] = useState(false);
  useEffect(() => {
    if (!data) return;
    if (data?.media_data?.count == 1 && data?.media_data.media_data[0].type === PostUtil.MediaType.VIDEO) {
      setIsVideo(true);
    }
  }, [data]);
  return <>{isVideo ? <FacebookPostVideoPreview data={data} /> : <FacebookPostImagesPreview data={data} />}</>;
};

export default FacebookPostPreview;
